export const SSO_AUTH_MODES = ['off', 'optional', 'required'];
export const SSO_AUTH_OFF = 'off';
export const SSO_AUTH_OPTIONAL = 'optional';
export const SSO_AUTH_REQUIRED = 'required';

// Only calendars the app created; non-sensitive, so the consent screen needs
// no Google verification. Requested by the integration card, checked by the API.
export const GOOGLE_CALENDAR_SCOPE = 'https://www.googleapis.com/auth/calendar.app.created';

export const EMBED_MESSAGE = {
  RESIZE: 'envelope:resize',
  EVENT_CREATED: 'envelope:event-created',
  // Fired when the AI one-shot prompt has finished building the registration
  // page. Hosts embedding the prompt element should navigate the iframe on THIS
  // event, not EVENT_CREATED — the latter fires at the bare event row, before
  // the page exists and while the builder loop is still running.
  PAGE_CREATED: 'envelope:page-created',
  AUTH_FAILED: 'envelope:auth-failed',
  // Sent by the google-calendar element on load and after every connect,
  // reconnect or removal, with { status, email }.
  GOOGLE_CALENDAR_CHANGED: 'envelope:google-calendar-changed',
};

export default {
  MAILING_BOUNCE_EXCEEDED_LIMIT: 50,
  MAILING_COMPLAINT_EXCEEDED_LIMIT: 4,
  RESERVED_DOMAINS: ['in', 'e', 'static-api', 'console', 'status', 'pay', 'show', 'docs', 'magic-demo'],
  MAXIMUM_QUANTITY_PER_TICKET_TYPE: 10,
  HARD_LIMIT_FOR_GUESTS_PER_EVENT: 10000,
  SUPPORTED_LANGUAGES: ['en', 'cs', 'pl', 'hu', 'de', 'es', 'fr', 'zh', 'pt', 'ja', 'it'], // 'sk'
  SUPPORTED_CURRENCIES: ['usd', 'eur', 'cad', 'gbp', 'jpy', 'aud', 'mxn', 'aed', 'chf', 'czk'],
  DEFAULT_TIMEZONE: 'Europe/London',
  RESERVED_GUEST_PROPERTIES: ['firstName', 'lastName', 'email', 'ticketType', 'lang'],
};
